import { render, staticRenderFns } from "./ThreeUpdateForm.vue?vue&type=template&id=1a5e44f8"
import script from "./ThreeUpdateForm.vue?vue&type=script&lang=js"
export * from "./ThreeUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports